// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginWrapper {
  min-height: 100vh;
  padding: 1px;
  background-size: cover;
}

.loginForm {
  max-width: 400px;
  margin: 64px auto;
  border-radius: 4px;
  padding: 24px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  background: #fff;
  box-sizing: border-box;
}
.loginForm .form-control {
  height: 42px;
  font-size: 16px;
  box-shadow: none;
  border-width: 0 0 1px;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
.loginForm .form-control:focus {
  box-shadow: none;
  border-bottom-width: 2px;
  border-bottom-color: #00c179;
}
.loginForm .control-label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.loginForm .btn-submit {
  display: block;
  width: 100%;
  height: 42px;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  background: #00c179;
  color: #fff;
}
.loginForm .btn-submit:hover {
  background: rgb(0, 167.5, 105.0129533679);
}

.loginWrapperInner {
  width: 100%;
}

@media (max-width: 599px) {
  .loginWrapper {
    display: flex;
    height: 100vh;
    align-items: center;
    background: #fff;
  }
  .loginForm {
    box-shadow: none !important;
    width: 100%;
    margin: 0 auto !important;
  }
}
.login-logo {
  display: block;
  margin: 16px auto 8px;
  max-width: 200px;
  max-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EAEA,YAAA;EACA,sBAAA;AADF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,yHAAA;EAGA,gBAAA;EACA,sBAAA;AAFF;AAIE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAGI;EACE,gBAAA;EACA,wBAAA;EACA,4BC3BO;AD0Bb;AAIE;EACE,0BAAA;EACA,eAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBC1CS;ED2CT,WAAA;AAHJ;AAII;EACE,yCAAA;AAFN;;AAOA;EACE,WAAA;AAJF;;AAMA;EACE;IACE,aAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;EAHF;EAKA;IACE,2BAAA;IACA,WAAA;IACA,yBAAA;EAHF;AACF;AAMA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AAJF","sourcesContent":["@import '../../assets/variables';\n.loginWrapper {\n  min-height: 100vh;\n  // background: url(/assets/images/login_wallpaper.png) no-repeat center top;\n  padding: 1px;\n  background-size: cover;\n}\n.loginForm {\n  max-width: 400px;\n  margin: 64px auto;\n  border-radius: 4px;\n  padding: 24px;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n\n  background: #fff;\n  box-sizing: border-box;\n\n  .form-control {\n    height: 42px;\n    font-size: 16px;\n    box-shadow: none;\n    border-width: 0 0 1px;\n    border-radius: 0;\n    padding-left: 0;\n    padding-right: 0;\n    &:focus {\n      box-shadow: none;\n      border-bottom-width: 2px;\n      border-bottom-color: $logoColor;\n    }\n  }\n  .control-label {\n    color: rgba(0, 0, 0, 0.54);\n    font-size: 12px;\n  }\n\n  .btn-submit {\n    display: block;\n    width: 100%;\n    height: 42px;\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: bold;\n    background: $logoColor;\n    color: #fff;\n    &:hover {\n      background: darken($logoColor, 5%);\n    }\n  }\n}\n\n.loginWrapperInner {\n  width: 100%;\n}\n@media (max-width: 599px) {\n  .loginWrapper {\n    display: flex;\n    height: 100vh;\n    align-items: center;\n    background: #fff;\n  }\n  .loginForm {\n    box-shadow: none !important;\n    width: 100%;\n    margin: 0 auto !important;\n  }\n}\n\n.login-logo {\n  display: block;\n  margin: 16px auto 8px;\n  max-width: 200px;\n  max-height: 100px;\n}\n","@import 'functions';\n@import 'mixins';\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
